export default __webpack_public_path__ + "static/media/8.7fb1e0a0.jpg";